import { render, staticRenderFns } from "./uploadSemenStock.vue?vue&type=template&id=75179d2c&"
import script from "./uploadSemenStock.vue?vue&type=script&lang=js&"
export * from "./uploadSemenStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports